import { ArrowRight, Phone, MapPin } from "lucide-react";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative pt-28 sm:pt-32 pb-20 sm:pb-28 overflow-hidden bg-[#FAFAFA]">
      <div aria-hidden className="absolute inset-0 -z-10 grain" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-12 gap-6 items-end">
          <div className="col-span-12 lg:col-span-9 reveal">
            <div className="flex items-center gap-3 mb-8" data-testid="hero-badge">
              <span className="w-8 h-px bg-[#0A0A0A]" />
              <span className="font-mono-tech text-[11px] sm:text-xs tracking-[0.25em] uppercase text-neutral-700">
                Experiență de 30+ ani / Fetești · Slobozia
              </span>
            </div>

            <h1
              data-testid="hero-heading"
              className="font-display text-[18vw] sm:text-[14vw] lg:text-[9vw] xl:text-[8vw] uppercase leading-[0.95] tracking-tight text-[#0A0A0A]"
            >
              Stație de
              <br />
              <span className="text-[#F59E0B]">Betoane</span>
              <br />
              Fetești <span className="text-neutral-300">/</span> Slobozia.
            </h1>

            <div className="mt-10 grid grid-cols-12 gap-6 items-start">
              <p className="col-span-12 md:col-span-7 text-base sm:text-lg leading-relaxed text-neutral-700 max-w-xl">
                Producem și livrăm beton de calitate pentru lucrări de construcții
                a clădirilor rezidențiale și nerezidențiale, prin
                <span className="font-bold text-black"> două puncte de lucru — Fetești și Slobozia</span>.
                Comenzile se fac
                <span className="font-bold text-black"> cu 48 de ore</span> înainte
                de turnare, telefonic, între 08:00 și 17:00.
              </p>

              <div className="col-span-12 md:col-span-5 flex flex-col gap-3">
                <a
                  href="tel:0766693105"
                  data-testid="hero-call-fetesti"
                  className="btn-amber rounded-sm inline-flex items-center justify-between gap-3 px-5 py-3.5 text-sm font-bold uppercase tracking-wider"
                >
                  <span className="flex items-center gap-2">
                    <Phone className="w-4 h-4" strokeWidth={2.5} />
                    Sună la Fetești
                  </span>
                  <span className="font-mono-tech text-[12px] tracking-wider">0766 693 105</span>
                </a>
                <a
                  href="tel:0722569492"
                  data-testid="hero-call-slobozia"
                  className="btn-ink rounded-sm inline-flex items-center justify-between gap-3 px-5 py-3.5 text-sm font-bold uppercase tracking-wider"
                >
                  <span className="flex items-center gap-2">
                    <Phone className="w-4 h-4" strokeWidth={2.5} />
                    Sună la Slobozia
                  </span>
                  <span className="font-mono-tech text-[12px] tracking-wider">0722 569 492</span>
                </a>
                <a
                  href="#beton"
                  data-testid="hero-services-cta"
                  className="rounded-sm inline-flex items-center justify-center gap-2 px-5 py-2.5 text-xs font-bold uppercase tracking-wider text-neutral-700 hover:text-black transition-colors"
                >
                  Vezi tipuri beton <ArrowRight className="w-3.5 h-3.5" />
                </a>
              </div>
            </div>
          </div>

          {/* Side stats */}
          <div className="col-span-12 lg:col-span-3 grid grid-cols-3 lg:grid-cols-1 gap-0 border border-black/10 bg-white">
            <Stat number="30+" label="ANI DE EXPERIENȚĂ" />
            <Stat number="02" label="PUNCTE DE LUCRU · FETEȘTI / SLOBOZIA" border />
            <Stat number="48h" label="PROGRAMARE ÎNAINTE" border />
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ number, label, border }) {
  return (
    <div
      className={`p-5 sm:p-6 ${border ? "lg:border-t border-l lg:border-l-0 border-black/10" : ""}`}
      data-testid={`stat-${label.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <div className="font-display text-4xl sm:text-5xl leading-none">{number}</div>
      <div className="font-mono-tech text-[10px] sm:text-[11px] tracking-[0.2em] uppercase text-neutral-600 mt-2">
        {label}
      </div>
    </div>
  );
}
